<template>
	<b-container class="show-document">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back')
					}}
				</b-button>
			</div>
			<div class="pull-right">
				<b-button
					variant="outline-primary"
					@click="excelExport('whDocTable', item.regNumber)"
					class="mr-2"
				>
					{{ $t('excel-export.download-excel') }}
				</b-button>
				<!--<b-button-->
					<!--variant="outline-dark"-->
					<!--@click="generateBarcode"-->
					<!--class="mr-2"-->
					<!--v-if="item.action === 'KIRIM'"-->
				<!--&gt;-->
					<!--<i class="fa fa-print"></i>-->
					<!--{{$t('pricing.print')}} {{$t('goods.barcode')}}-->
				<!--</b-button>-->
				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{$t('pricing.print')}}
				</b-button>
				<b-button
					v-if="item.editable"
					@click="openSidebar"
					variant="outline-dark"
					class="mr-2"
				>
					<i class="fa fa-edit"></i>
					{{ $t('Изменить') }}
				</b-button>
				<!--<b-button
					v-if="item.editable"
					@click="showConfirm(item.id)"
					variant="outline-danger"
					:key="item.id + 'delete'"
					:id="'popOverDelete'+item.id"
				>
					<i class="fa fa-trash"></i>
					{{ $t('Delete') }}
				</b-button>
				<b-popover
					:key="item.id + 'popover'"
					:target="'popOverDelete'+item.id"
					placement="bottom"
					:ref="'popover'+item.id"
					class="refDeleteConfirm"
				>
					<template slot="title">
						<b-button @click="closeConfirm(item.id)" class="close" aria-label="Close"
								  style="margin-left: 5px">
							<span class="d-inline-block" aria-hidden="true">&times;</span>
						</b-button>
						{{ $t('want_to_delete?') }}
					</template>

					<div>
						<div class="row mt-1">
							<div class="col-6">
								<b-button variant="outline-danger" size="sm" block @click="closeConfirm(item.id)">
									{{$t('actions.no') }}
								</b-button>
							</div>
							<div class="col-6">
								<b-button variant="outline-success" size="sm" block @click="remove">{{ $t('actions.yes') }}
								</b-button>
							</div>
						</div>
					</div>
				</b-popover>-->
				<!--<div class="pull-right ml-2 pt-2">
					<b-form-group>
						<b-form-checkbox-group switches disabled v-model="income" name="switches1"
											   :options="[{text: 'Income', value: true}]"/>
					</b-form-group>
				</div>-->
				<!--<div class="pull-right ml-2">
					<b-form-group>
						<b-form-radio-group
							id="btnradios1"
							buttons
							v-model="priceType"
							button-variant="outline-primary"
							:options="[
						{
						text: 'Сум',
						value: 'uzs'
						},
						{
						text: 'USD',
						value: 'usd'
						},

					]"
							name="radiosBtnDefault"
						/>
					</b-form-group>
				</div>-->
<!--				<div class="clearfix"></div>-->
			</div>
			<div class="clearfix"></div>

		</div>
		<div class="doc-body">
			<b-card class="p-3">
				<b-row class="mb-3">
					<b-col></b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center day-wrapper">
							{{formatDate(item.regDate, 'DD')}}
						</div>
					</b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center ">
							{{formatDate(item.regDate, 'MM')}}
						</div>
					</b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center">
							{{formatDate(item.regDate, 'YYYY')}}
						</div>
					</b-col>
				</b-row>
				<div class="text-center">
					<h3 class="font-weight-bold text-uppercase">{{$t(item.documentType)}} №: <span class="small">{{item.regNumber}}</span>
					</h3>
				</div>
				<div class="text-right">
					<p>
						<strong>{{$t('incomes.create.to-warehouse')}}:</strong> {{item.toDepartmentName}}
					</p>
					<p>
						<strong>Вес:</strong> {{updateWeight(item)}}

					</p>
					<p v-if="item.responsible1Name">
						<strong>{{$t('incomes.responsible')}}:</strong>
						{{item.responsible1Name}} <br>
						<span v-if="item.responsible1Name">{{item.responsible2Name}}</span>
					</p>
					<p v-if="item.reason">
						<strong>{{$t('incomes.reason')}}:</strong> {{item.reason}}
					</p>
				</div>

				<b-row class="mb-2">
					<b-col cols="4" v-if="item.fromEmployeeName">
						<strong>{{ $t('incomes.create.from') }}:</strong> <u class="underline ml-3">&nbsp; &nbsp;
						{{ item.fromEmployeeName }}
						&nbsp; &nbsp;
					</u>
					</b-col>
					<b-col v-if="item.toEmployeeName">
						<strong>{{ $t('incomes.create.to') }}:</strong> <u class="underline ml-3">&nbsp; &nbsp;
						{{ item.toEmployeeName }}
						&nbsp; &nbsp;
					</u>
					</b-col>
				</b-row>
				<div class="generalTableClass documentItems">
					<table class="table table-striped" id="whDocTable">
						<thead>
						<tr>
							<th class="p-1"> №</th>
							<th class="p-1">{{$t('goods.artikul')}}</th>
							<th class="p-1">{{$t('goods.color')}}</th>
							<th class="p-1">{{$t('goods.size')}}</th>
							<th class="p-1">{{$t('incomes.create.product')}}</th>
							<th class="p-1">{{$t('goods.create.unit')}}</th>
							<!--<th v-if="incomeField && priceType === 'usd'" class="p-1">{{$t('Incoming Price USD')}}</th>-->
<!--							<th v-if="priceType === 'usd'" class="p-1">{{$t('incomes.create.price')}}</th>-->
							<th v-if="priceType === 'uzs'  && (item.action !== 'CHIQIM' && item.action !== 'KOCHIRISH') && !item.fromDepartmentId"
								class="p-1">{{$t('incomes.create.incoming-price')}}
							</th>
							<th v-else-if="priceType === 'uzs'" class="p-1">{{$t('incomes.create.price')}}</th>
							<th class="p-1" style="width: 6%; text-align: center;">{{$t('sale.kol-vo')}}</th>
							<th class="p-1">{{$t('total-amount')}}</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="whItem,index in packListItems" :key="whItem.id + 'field'">
							<td class="p-1">{{index + 1 }}</td>
							<td class="p-1">{{ whItem.model_no ? whItem.model_no : '-' }}</td>
							<td class="p-1">{{ whItem.color_code ? whItem.color_code : '-' }}</td>
							<td class="p-1">{{ whItem.size ? whItem.size.name : '-' }}</td>
							<td class="p-1">{{ whItem.name ? whItem.name.substring(0, 30) : '-' }}</td>
							<td class="p-1">{{whItem.unitName}}</td>
						</tr>
						</tbody>

						<tfoot>
						<tr>
							<td
								v-if="priceType === 'uzs' && item.action !== 'CHIQIM' && item.action !== 'KOCHIRISH' && !item.fromDepartmentId"
								colspan="7"
								class="p-1 pr-3"
								style="text-align: right;"
							>
								<strong class="font-lg">Итого</strong>
							</td>
							<td
								v-else
								colspan="7"
								class="p-1 pr-3"
								style="text-align: right;"
							>
								<strong class="font-lg">Итого</strong>
							</td>
							<td class="p-1" style="text-align: center; font-weight: bold; vertical-align: middle;">
								{{ totalCount }}
							</td>

							<!--<td class="p-1" v-if="incomeField && priceType === 'usd'">
								{{ totalIncome.usd | currency({symbol: 'USD', symbolPosition: 'back'})}}
							</td>-->
							<td class="p-1" v-if="priceType === 'uzs' &&
							 			item.action !== 'CHIQIM' && item.action !== 'KOCHIRISH' && !item.fromDepartmentId">
								<span v-if="totalIncome.uzs > 0">{{ totalIncome.uzs | currency({symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName, fractionCount: 2, symbolPosition: 'back'})}}</span>
								<span v-else>-</span>
							</td>
							<!--<td class="p-1" v-if="priceType === 'usd'">
								{{ totalPrice.usd | currency({symbol: 'USD', symbolPosition: 'back'}) }}
							</td>-->
							<td class="p-1" v-else-if="priceType === 'uzs' && totalPrice.uzs > 0"
								style="vertical-align: middle; font-weight: bold;">
								{{ totalPrice.saleTypePrice | currency({symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName, fractionCount: 2, symbolPosition: 'back'}) }}
							</td>



							<td class="p-1" v-else-if="priceType === 'uzs'"
								style="vertical-align: middle; font-weight: bold;">
								-
							</td>
						</tr>
						</tfoot>
					</table>
					<div v-if="loader" class="spinner-wrapper">
						<b-spinner variant="primary"></b-spinner>
					</div>
				</div>
				<div>
					<div class="d-flex justify-content-end">
						<label class="control-label font-weight-bold">{{ $t('comment') }}:</label>
						<p class="ml-1">{{ item.comment }}</p>
					</div>
				</div>
			</b-card>
		</div>
		<vs-sidebar :click-not-close="true"
					position-right
					parent="body"
					default-index="1"
					color="primary"
					class="create-modal"
					spacer
					v-model="sidebar.open">
			<b-container index="1" v-if="sidebar.open">
				<create-form
					:mode="'edit'"
					:edit-item="item"
					@close="sidebar.open = false"
					@reload="get"
				></create-form>
			</b-container>
		</vs-sidebar>
	</b-container>
</template>

<script>
	import WhDocument from "../../../../services/wh-document.service";
	import moment from 'moment'
	import CreateForm from "../blocks/CreateForm";
	import {mapActions, mapState} from "vuex"

	export default {
		name: 'Show',

		data() {
			return {
			    loader: false,
				item: {},
				totalPrice: {
					uzs: 0,
					usd: 0,
					saleTypePrice: 0,
				},
				priceType: 'uzs',
				income: [],
				totalIncome: {
					uzs: 0,
					usd: 0
				},
				sidebar: {
					open: false,
					close: false
				},
				backTo: null,
			}
		},

		methods: {
			...mapActions('warehouse', [
				'getPackListAction'
			]),
		updateWeight(item){
				if (item.sumWeightAllItems>1000) {
					return item.sumWeightAllItems/1000 + ' кг';
				}
				if (item.sumWeightAllItems<1000){
					return item.sumWeightAllItems + ' гр';
				}
				if (item.sumWeightAllItems>1000000) {
					return item.sumWeightAllItems/1000000 + ' тонна';
				}
			},
			async get() {
				if (this.$can('get', 'warehouse-document')) {
				    this.loader = true;
						await this.getPackListAction(this.$route.params.id);
						this.loader = false;
				}
			},
			sumPrice(item) {
				if (typeof item.whItems === 'object') {
					Object.values(item.whItems).map(item => {
						if (item.priceUsd) this.totalPrice.usd += item.priceUsd * item.count;
						if (item.priceUzs) this.totalPrice.uzs += item.priceUzs ? item.priceUzs * item.count : 0;
						if (item.saleTypePrice) this.totalPrice.saleTypePrice += item.saleTypePrice ? item.saleTypePrice * item.count : 0;
					});
				}
			},
			sumIncome(item) {
				if (typeof item.whItems === 'object') {
					Object.values(item.whItems).map(item => {
						this.totalIncome.usd += item.incomingPriceUsd * item.count;
						this.totalIncome.uzs += item.incomingPriceUzs ? item.incomingPriceUzs * item.count : 0;
					});
				}
			},
			formatDate(date, format = 'DD-MM-YYYY') {
				if (date) {
					const split = date.split(' ');
					date = split[0];
					const revers = date.split('-');
					date = revers[2] + '-' + revers[1] + '-' + revers[0] + 'T00:00:00';
					return moment(String(date)).format(format)
				}
			},
			goBackToFrom() {
				this.$router.back();
			},
			print() {
				window.print();
			},
			openSidebar() {
				setTimeout(() => {
					this.sidebar.open = true
				}, 200)
			},

			generateBarcode() {
				this.$router.push(`/warehouse-management/income/barcodes/${this.$route.params.id}`);

			},

			remove() {
				WhDocument.remove(this.item.id).then(response => {
					this.$router.push('/warehouse-management/income');
				})
			},

			showConfirm(item) {
				let refName = 'popover' + item;
				this.$refs[refName].$emit('open')
			},
			closeConfirm(item) {
				let refName = 'popover' + item;
				this.$refs[refName].$emit('close')
			},
			excelExport(tableID, filename = '') {

				let downloadLink;

				let dataType = 'text/xls;charset=UTF-8';
				//var dataType = 'application/vnd.ms-excel';
				let tableSelect = document.getElementById(tableID);
				let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

				// Specify file name
				filename = filename.length > 0 ? filename + '.xls' : 'excel_data.xls';
				// Create download link element
				downloadLink = document.createElement("a");

				document.body.appendChild(downloadLink);

				if (navigator.msSaveOrOpenBlob) {
					let blob = new Blob(['\ufeff', tableSelect], {
						encoding: "utf-8",
						type: dataType
					});
					navigator.msSaveOrOpenBlob(blob, filename);
				} else {
					// Create a link to the file
					downloadLink.href = 'data:' + dataType + ', ' +  tableHTML;

					// Setting the file name
					downloadLink.download = filename;

					//triggering the function
					downloadLink.click();
				}

			},


		},
		created() {
			this.get();
		},
		computed: {
			/*incomeField() {
				return this.income[0]
			},*/
			...mapState('warehouse', [
				'packListItems'
			]),
			totalCount() {
				let sum = 0;
				if (this.item.whItems) {
					if (this.item.whItems.length > 0) {
						this.item.whItems.forEach(el => {
							sum += el.count;
						});
					}
				}
				return sum;
			}
		},
		components: {
			CreateForm
		},
	}
</script>

<style scoped lang="scss">
	@media print {
		.hidden-print {
			display: none;
		}

		.card {
			box-shadow: none;
		}
	}

	.generalTableClass {
		.table {
			td, th {
				font-size: 12px;
			}
		}
	}
	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
</style>
